module.exports = __webpack_public_path__ + "static/img/brees-2012-top-image.f40a7b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2012-top-image.jpg
// module id = sydR
// module chunks = 1